/**
 * Condições de pagamento — fonte única da verdade.
 *
 * Regra do negócio (MS Eletric):
 * - TODOS os veículos aceitam cartão de crédito em até 21x (com juros) e à vista.
 * - Um subgrupo também aceita FINANCIAMENTO em até 48x (lista abaixo).
 *
 * Para mudar prazos/textos, altere só este arquivo: reflete no site inteiro.
 */

/** Slugs dos modelos elegíveis a financiamento em até 48x. */
export const FINANCEABLE_SLUGS = new Set<string>([
  "bike-350",
  "bike-500",
  "bike-ms-600",
  "new-holiday",
  "tour-3k",
  "rhino-delivery",
  "cargo",
]);

export const isFinanceable = (slug: string): boolean => FINANCEABLE_SLUGS.has(slug);

export interface PaymentMethod {
  /** id estável, usado como valor em formulários */
  id: "financiamento" | "cartao" | "vista";
  label: string;
  detail: string;
}

export const PAYMENT_METHODS: Record<PaymentMethod["id"], PaymentMethod> = {
  financiamento: { id: "financiamento", label: "Financiamento", detail: "em até 48x" },
  cartao: { id: "cartao", label: "Cartão de crédito", detail: "em até 21x (com juros)" },
  vista: { id: "vista", label: "À vista", detail: "Pix ou dinheiro" },
};

/** Métodos disponíveis para um modelo (na ordem de destaque). */
export function paymentMethodsFor(slug: string): PaymentMethod[] {
  const methods: PaymentMethod[] = [];
  if (isFinanceable(slug)) methods.push(PAYMENT_METHODS.financiamento);
  methods.push(PAYMENT_METHODS.cartao, PAYMENT_METHODS.vista);
  return methods;
}

/** Linha curta (ex.: abaixo do preço na página de produto). */
export function paymentSummary(slug: string): string {
  return isFinanceable(slug)
    ? "Financiamento em até 48x · cartão em até 21x · à vista"
    : "Cartão em até 21x (com juros) · à vista";
}

/** Versão mínima para o card do catálogo (pouco espaço). */
export function paymentSummaryShort(slug: string): string {
  return isFinanceable(slug) ? "Financiamento ou até 21x no cartão" : "Até 21x no cartão · à vista";
}

/** Resumo geral (catálogo/home): vale para o conjunto de modelos. */
export const PAYMENT_CATALOG: PaymentMethod[] = [
  { id: "financiamento", label: "Financiamento", detail: "modelos selecionados" },
  PAYMENT_METHODS.cartao,
  PAYMENT_METHODS.vista,
];
